import { HeaderShim } from '../fuselage/global/header/header'
import { PageHeader } from "../fuselage/layout/investors/page-header/page-header"
import { NewFeatures } from '../fuselage/layout/investors/new-features/new-features'
import { Callout } from  '../fuselage/layout/investors/callout/callout'
import { CardSlider } from '../fuselage/layout/investors/card-slider/card-slider'
import { ContentCard } from "../fuselage/components/content-card/content-card"
import { SpeakerCarousel } from '../fuselage/blocks/speaker-carousel/speaker-carousel'
import { SpeakerCard } from "../fuselage/components/speaker-card/speaker-card"
import { Pop } from '../fuselage/animation/animation'

export default function Investors ({ articles, speakers }) {

    // console.log( 'articles:', articles )
    // console.log( 'speakers:', speakers )

    return (
        <>

            <HeaderShim/>

            <PageHeader/>

            <SpeakerCarousel heading={'Investor-Speakers at FHS Africa 2025'} ctaLink={'/speakers'} ctaLabel={'See all speakers'}>
                {
                    speakers.map( speaker => (
                        <Pop key={speaker.id}>
                            <SpeakerCard 
                                key={speaker.id}
                                url={`/speakers/profile/${speaker.slug}`}
                                photoUrl={speaker.avatar[0].url}
                                fullName={speaker.title}
                                jobTitle={speaker.positions[0].jobTitle}
                                company={speaker.positions[0].organisation}
                            />
                        </Pop>
                    ))
                }
            </SpeakerCarousel>

            <NewFeatures />

            <Callout />

            <section className="block">
                <div className="container">
                    <p className='fs-1 fw-500 c-primary'>Deals Signed at FHS Africa</p>
                </div>

                <div className="container">
                    <CardSlider>
                        {
                            articles.map( entry => (
                                <ContentCard
                                    key={entry.id}
                                    url={`/content-library/${entry.slug}`}
                                    heroUrl={entry.contentLibraryHero && entry.contentLibraryHero[0] ? entry.contentLibraryHero[0].url : null}
                                    heading={entry.title}
                                    excerpt={''}
                                    contentTypes={entry.contentTypes}
                                    postDate={entry.postDate}
                                />
                            ))
                        }
                    </CardSlider>
                </div>
            </section>

        </>
    )
}




import { gql } from "@apollo/client"
import craftApolloClient from "./api/apollo"

export async function getStaticProps() {
    const { data } = await craftApolloClient().query({
        query: gql`
            query Articles {
                entries(site: "${process.env.SITE_HANDLE}", section: "contentLibrary" id: [ 204140, 204009, 177023, 117582 ]) {
                    ... on contentLibrary_article_Entry {
                        id
                        slug
                        title
                        postDate
                        excerpt
                        contentLibraryHero {
                            id
                            url
                            width
                            height
                        }
                        contentTypes {
                            ... on contentLibrary_Category {
                                id
                                title
                            }
                        }
                    }
                }
                categories (group: "contentLibrary", id: [7701, 7702, 7704, 121314]) {
                    id
                    title
                    slug
                }
                speakers: entries(site: "${process.env.SITE_HANDLE}", id: 252814) {
                    id
                    slug
                    title
                    ... on profileGroups_default_Entry {
                        id
                        profiles {
                            ... on profiles_profile_Entry {
                                id
                                title
                                slug
                                avatar {
                                    url
                                    width
                                    height
                                }
                                positions {
                                    ... on positions_BlockType {
                                        id
                                        jobTitle
                                        organisation
                                    }
                                }
                            }
                        }
                    }
                }
            }
          
        `
        })

        return {
        props: {
            articles: data.entries,
            categories: data.categories,
            speakers: data.speakers[0].profiles
        },
    }
}